import React from 'react'

const Gallery = (props) => (
  <div className='photos-gallery' {...props} />
)

export default Gallery
